import { Box, List, ListItem, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import CloudIcon from "@mui/icons-material/Cloud";
import DescriptionIcon from "@mui/icons-material/Description";
import HomeOutlinedcon from '@mui/icons-material/HomeOutlined';
import SearchIcon from "@mui/icons-material/Search";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import { useAuth } from "../providers/AuthProvider";

const SIDEBAR_WIDTH = 274;
const HEADER_HEIGHT = 65;

const candidateNavigationItems = [
  { text: "Home", icon: HomeOutlinedcon, path: "/" },
  { text: "CVs", icon: DescriptionIcon, path: "/cvs" },
  { text: "Files & Media", icon: CloudIcon, path: "/uploaded-files" },
];

const adminNavigationItems = [
  { text: "Dashboard", icon: HomeOutlinedcon, path: "/" },
  { text: "Search", icon: SearchIcon, path: "/admin/search" },
  { text: "User Management", icon: PeopleOutlineIcon, path: "/admin/users" },
  { text: "Manage Invites", icon: SendOutlinedIcon, path: "/admin/invites" },
  { text: "Manage Opportunities", icon: BusinessCenterOutlinedIcon, path: "/admin/opportunities" },
];

const Sidebar = () => {
  const keycloak = useAuth();
  const isAdmin = keycloak?.hasRealmRole?.("admin") ?? false;
  const navigationItems = isAdmin ? adminNavigationItems : candidateNavigationItems;
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const pathname = location.pathname;

  const isActive = (item) => {
    return pathname === item.path || pathname.startsWith(item.path + "/");
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        minWidth: SIDEBAR_WIDTH,
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: theme.palette.background.paper,
        borderRight: "none",
        boxShadow:
          "0px 2px 1px -1px #00000033, 0px 1px 1px 0px #00000024, 0px 1px 3px 0px #0000001F",
        overflowY: "auto",
        position: "fixed",
        left: 0,
        top: `${HEADER_HEIGHT}px`,
        zIndex: 1000,
      }}
    >
      <List sx={{ padding: "8px" }}>
        {navigationItems.map((item) => {
          const active = isActive(item);
          return (
          <ListItem
            key={item.text}
            onClick={() => handleNavigation(item.path)}
            sx={{
              cursor: "pointer",
              width: "258px",
              height: "40px",
              padding: "8px 16px",
              margin: 0,
              marginBottom: "8px",
              borderRadius: "4px",
              gap: "8px",
              backgroundColor: active ? theme.palette.grey[400] : "transparent",
              color: active ? "#000000" : theme.palette.grey[500],
              "&:hover": {
                backgroundColor: theme.palette.grey[400],
                color: "#000000",
                "& .MuiListItemIcon-root .MuiSvgIcon-root": {
                  color: "#000000",
                },
              },
              "& .MuiListItemIcon-root .MuiSvgIcon-root": {
                color: theme.palette.grey[500],
              },
              display: "flex",
              alignItems: "center",
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: "24px",
                width: "24px",
                height: "24px",
                marginRight: "8px",
              }}
            >
              <item.icon
                sx={{
                  fontSize: "24px",
                  width: "24px",
                  height: "24px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              style={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
              }}
              primary={item.text} 
            />
          </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

const MainLayout = ({ children, disablePadding = false }) => {
  return (
    <>
      <Sidebar />
      <div
        style={{
          position: "fixed",
          top: "65px",
          left: "258px",
          width: "calc(100% - 258px)",
          height: "calc(100% - 65px)",
          overflow: "auto",
          padding: disablePadding ? 0 : "32px",
          boxSizing: "border-box",
          background: "#EAE7E6",
        }}
      >
        {children}
      </div>
    </>
  );
};

export default MainLayout;
